const types = {
  FETCH_OPERATOR_TRIPS_START: 'FETCH_OPERATOR_TRIPS_START',
  FETCH_OPERATOR_TRIPS_SUCCESS: 'FETCH_OPERATOR_TRIPS_SUCCESS',
  FETCH_OPERATOR_TRIPS_FAILURE: 'FETCH_OPERATOR_TRIPS_FAILURE',
  CLEAR_OPERATOR_TRIPS: 'CLEAR_OPERATOR_TRIPS',

  FETCH_STATES_START: 'FETCH_STATES_START',
  FETCH_STATES_SUCCESS: 'FETCH_STATES_SUCCESS',
  FETCH_STATES_FAILURE: 'FETCH_STATES_FAILURE',

  FETCH_LOADS_START: 'FETCH_LOADS_START',
  FETCH_LOADS_SUCCESS: 'FETCH_LOADS_SUCCESS',
  FETCH_LOADS_FAILURE: 'FETCH_LOADS_FAILURE',

  CALL_POC_START: 'CALL_POC_START',
  CALL_POC_SUCCESS: 'CALL_POC_SUCCESS',
  CALL_POC_FAILURE: 'CALL_POC_FAILURE',

  SAVE_OP_QUOTE_AMOUNT: 'SAVE_OP_QUOTE_AMOUNT',
  RESET_OP_QUOTE_AMOUNT: 'RESET_OP_QUOTE_AMOUNT',

  SET_SELECTED_STATE: 'SET_SELECTED_STATE',
  SET_FIRST_ACCEPTANCE: 'SET_FIRST_ACCEPTANCE',
  SET_SHOW_BACK_WARNING: 'SET_SHOW_BACK_WARNING',
  SET_LOAD_SEEN: 'SET_LOAD_SEEN',

  SAVE_OP_RESPONSE_START: 'SAVE_OP_RESPONSE_START',
  SAVE_OP_RESPONSE_SUCCESS: 'SAVE_OP_RESPONSE_SUCCESS',
  SAVE_OP_RESPONSE_REJECTED: 'SAVE_OP_RESPONSE_SUCCESS_REJECTED',
  SAVE_OP_RESPONSE_FAILURE: 'SAVE_OP_RESPONSE_FAILURE',
  CLEAR_LOADS_FLAGS: 'CLEAR_LOADS_FLAGS',

  FETCH_TRIP_EXPENSE_START: 'FETCH_TRIP_EXPENSE_START',
  FETCH_TRIP_EXPENSE_START_V2: 'FETCH_TRIP_EXPENSE_START_V2',
  FETCH_TRIP_EXPENSE_SUCCESS: 'FETCH_TRIP_EXPENSE_SUCCESS',
  FETCH_TRIP_EXPENSE_FAILURE: 'FETCH_TRIP_EXPENSE_FAILURE',

  FETCH_TRIP_TRACKING_DETAILS_START: 'FETCH_TRIP_TRACKING_DETAILS_START',
  FETCH_TRIP_TRACKING_DETAILS_START_V2: 'FETCH_TRIP_TRACKING_DETAILS_START_V2',
  FETCH_TRIP_TRACKING_DETAILS_SUCCESS: 'FETCH_TRIP_TRACKING_DETAILS_SUCCESS',
  FETCH_TRIP_TRACKING_DETAILS_FAILURE: 'FETCH_TRIP_TRACKING_DETAILS_FAILURE',
  TRIP_TRACKING_DATA_RESET: 'TRIP_TRACKING_DATA_RESET',

  START_TRIP_POD_OTP_POLL: 'START_TRIP_POD_OTP_POLL',
  STOP_TRIP_POD_OTP_POLL: 'STOP_TRIP_POD_OTP_POLL',
  MERGE_TRIP_POD_OTP_WIDGETS: 'MERGE_TRIP_POD_OTP_WIDGETS',

  FETCH_PAYMENT_HISTORY_START: 'FETCH_PAYMENT_HISTORY_START',
  FETCH_PAYMENT_HISTORY_START_V2: 'FETCH_PAYMENT_HISTORY_START_V2',
  FETCH_PAYMENT_HISTORY_SUCCESS: 'FETCH_PAYMENT_HISTORY_SUCCESS',
  FETCH_PAYMENT_HISTORY_FAILURE: 'FETCH_PAYMENT_HISTORY_FAILURE',
  FETCH_TRIP_SUMMARY_START: 'FETCH_TRIP_SUMMARY_START',
  FETCH_TRIP_SUMMARY_START_V2: 'FETCH_TRIP_SUMMARY_START_V2',
  FETCH_TRIP_SUMMARY_SUCCESS: 'FETCH_TRIP_SUMMARY_SUCCESS',
  FETCH_TRIP_SUMMARY_FAILURE: 'FETCH_TRIP_SUMMARY_FAILURE',

  FETCH_LOAD_DETAILS_START: 'FETCH_LOAD_DETAILS_START',
  FETCH_LOAD_DETAILS_SUCCESS: 'FETCH_LOAD_DETAILS_SUCCESS',
  FETCH_LOAD_DETAILS_FAILURE: 'FETCH_LOAD_DETAILS_FAILURE',

  FETCH_LOAD_QUOTE_QUALITY_START: 'FETCH_LOAD_QUOTE_QUALITY_START',
  FETCH_LOAD_QUOTE_QUALITY_SUCCESS: 'FETCH_LOAD_QUOTE_QUALITY_SUCCESS',
  FETCH_LOAD_QUOTE_QUALITY_FAILURE: 'FETCH_LOAD_QUOTE_QUALITY_FAILURE',
  POST_LOAD_QUOTE_START: 'POST_LOAD_QUOTE_START',
  POST_LOAD_QUOTE_SUCCESS: 'POST_LOAD_QUOTE_SUCCESS',
  POST_LOAD_QUOTE_FAILURE: 'POST_LOAD_QUOTE_FAILURE',
  POST_LOAD_QUOTE_RESET: 'POST_LOAD_QUOTE_RESET',

  GET_SEARCH_OPTIONS_START: 'GET_SEARCH_OPTIONS_START',
  GET_SEARCH_OPTIONS_SUCCESS: 'GET_SEARCH_OPTIONS_SUCCESS',
  GET_SEARCH_OPTIONS_FAILURE: 'GET_SEARCH_OPTIONS_FAILURE',

  GET_SELECT_PLACE_START: 'GET_SELECT_PLACE_START',
  GET_SELECT_PLACE_SUCCESS: 'GET_SELECT_PLACE_SUCCESS',
  GET_SELECT_PLACE_FAILURE: 'GET_SELECT_PLACE_FAILURE',

  GET_EMPTY_SEARCH_START: 'GET_EMPTY_SEARCH_START',
  GET_EMPTY_SEARCH_SUCCESS: 'GET_EMPTY_SEARCH_SUCCESS',
  GET_EMPTY_SEARCH_FAILURE: 'GET_EMPTY_SEARCH_FAILURE',

  GET_PLACEHOLDER_BANNER_DETAILS_START: 'GET_PLACEHOLDER_BANNER_DETAILS_START',
  GET_PLACEHOLDER_BANNER_DETAILS_SUCCESS: 'GET_PLACEHOLDER_BANNER_DETAILS_SUCCESS',
  GET_PLACEHOLDER_BANNER_DETAILS_FAILURE: 'GET_PLACEHOLDER_BANNER_DETAILS_FAILURE',

  POST_UPLOAD_DOC_POD_START: 'POST_UPLOAD_DOC_POD_START',
  POST_UPLOAD_DOC_POD_SUCCESS: 'POST_UPLOAD_DOC_POD_SUCCESS',
  GET_RESOURCE_KEY_POD: 'GET_RESOURCE_KEY_POD',
  GET_UPLOADED_IMAGES_START: 'GET_UPLOADED_IMAGES_START',
  GET_UPLOADED_IMAGES_SUCCESS: 'GET_UPLOADED_IMAGES_SUCCESS',
  GET_UPLOADED_IMAGES_FAILURE: 'GET_UPLOADED_IMAGES_FAILURE',

  POST_AWS_SUCCESS: 'POST_AWS_SUCCESS',
  GET_POD_IMG_AWS_URL: 'GET_POD_IMG_AWS_URL',

  GET_UPLOADED_IMAGES_SINGLE_START: 'GET_UPLOADED_IMAGES_SINGLE_START',
  GET_UPLOADED_IMAGES_SINGLE_SUCCESS: 'GET_UPLOADED_IMAGES_SINGLE_SUCCESS',

  GET_UPLOADED_IMAGES_SINGLE_FAILURE: 'GET_UPLOADED_IMAGES_SINGLE_FAILURE',

  FETCH_POD_DETAILS_START: 'FETCH_POD_DETAILS_START',
  FETCH_POD_DETAILS_SUCCESS: 'FETCH_POD_DETAILS_SUCCESS',
  FETCH_POD_DETAILS_FAILURE: 'FETCH_POD_DETAILS_FAILURE',

  POST_POD_DATA_UPDATE_START: 'POST_POD_DATA_UPDATE_START',
  POST_POD_DATA_UPDATE_SUCCESS: 'POST_POD_DATA_UPDATE_SUCCESS',
  POST_POD_DATA_UPDATE_FAILURE: 'POST_POD_DATA_UPDATE_FAILURE',

  UNLOADING_SEARCH_RESULTS_START: 'UNLOADING_SEARCH_RESULTS_START',
  UNLOADING_SEARCH_RESULTS_SUCCESS: 'UNLOADING_SEARCH_RESULTS_SUCCESS',
  UNLOADING_SEARCH_RESULTS_FAILURE: 'UNLOADING_SEARCH_RESULTS_FAILURE',
  RESET_LIST: 'RESET_LIST',

  VEHCILE_AVAIL_MODAL_SHOW_START: 'VEHCILE_AVAIL_MODAL_SHOW_START',
  VEHCILE_AVAIL_MODAL_SHOW_SUCCESS: 'VEHCILE_AVAIL_MODAL_SHOW_SUCCESS',
  VEHCILE_AVAIL_MODAL_SHOW_FAILURE: 'VEHCILE_AVAIL_MODAL_SHOW_FAILURE',

  SURVEY_GET_QUESTION_START: 'SURVEY_GET_QUESTION_START',
  SURVEY_GET_QUESTION_SUCCESS: 'SURVEY_GET_QUESTION_SUCCESS',
  SURVEY_GET_QUESTION_FAILURE: 'SURVEY_GET_QUESTION_FAILURE',

  POST_SURVEY_FORM_START: 'POST_SURVEY_FORM_START',
  POST_SURVEY_FORM_SUCCESS: 'POST_SURVEY_FORM_SUCCESS',
  POST_SURVEY_FORM_FAILURE: 'POST_SURVEY_FORM_FAILURE',

  INITIATE_MEMBERSHIP_PAYMENT_START: 'INITIATE_MEMBERSHIP_PAYMENT_START',
  INITIATE_MEMBERSHIP_PAYMENT_SUCCESS: 'INITIATE_MEMBERSHIP_PAYMENT_SUCCESS',
  INITIATE_MEMBERSHIP_PAYMENT_FAILURE: 'INITIATE_MEMBERSHIP_PAYMENT_FAILURE',
  INITIATE_MEMBERSHIP_PAYMENT_RESET: 'INITIATE_MEMBERSHIP_PAYMENT_RESET',

  MEMBERSHIP_PAYMENT_PROCESS_START: 'MEMBERSHIP_PAYMENT_PROCESS_START',
  MEMBERSHIP_PAYMENT_PROCESS_SUCCESS: 'MEMBERSHIP_PAYMENT_PROCESS_SUCCESS',
  MEMBERSHIP_PAYMENT_PROCESS_FAILURE: 'MEMBERSHIP_PAYMENT_PROCESS_FAILURE',

  POST_OTP_START: 'POST_OTP_START',
  POST_OTP_SUCCESS: 'POST_OTP_SUCCESS',
  POST_OTP_FAILURE: 'POST_OTP_FAILURE',

  POST_OTP_STAGE_START: 'POST_OTP_STAGE_START',
  POST_OTP_STAGE_SUCCESS: 'POST_OTP_STAGE_SUCCESS',
  POST_OTP_STAGE_FAILURE: 'POST_OTP_STAGE_FAILURE',

  TRIP_DETAIL_STATE_CHANGE_CONFIRM_WARNING_START: 'TRIP_DETAIL_STATE_CHANGE_CONFIRM_WARNING_START',
  TRIP_DETAIL_STATE_CHANGE_CONFIRM_WARNING_STOP: 'TRIP_DETAIL_STATE_CHANGE_CONFIRM_WARNING_STOP',

  TRIP_DETAIL_STATE_CHANGE_VALIDATION_START: 'TRIP_DETAIL_STATE_CHANGE_VALIDATION_START',
  TRIP_DETAIL_STATE_CHANGE_VALIDATION_SUCCESS: 'TRIP_DETAIL_STATE_CHANGE_VALIDATION_SUCCESS',
  TRIP_DETAIL_STATE_CHANGE_VALIDATION_FAILURE: 'TRIP_DETAIL_STATE_CHANGE_VALIDATION_FAILURE',

  FETCH_APP_CONFIG: 'MARKETPLACE/FETCH_APP_CONFIG',
  FETCH_APP_CONFIG_SUCCESS: 'MARKETPLACE/FETCH_APP_CONFIG_SUCCESS',
  FETCH_APP_CONFIG_FAILURE: 'MARKETPLACE/FETCH_APP_CONFIG_FAILURE',

  FETCH_OPERATOR_PROFILE_START: 'FETCH_OPERATOR_PROFILE_START',
  FETCH_OPERATOR_PROFILE_SUCCESS: 'FETCH_OPERATOR_PROFILE_SUCCESS',

  FETCH_OPERATOR_PROFILE_FAILURE: 'FETCH_OPERATOR_PROFILE_FAILURE',

  // for outer POD uploader
  POST_IMG_AWS: 'POST_IMG_AWS',
  POST_IMG_AWS_SUCCESS: 'POST_IMG_AWS_SUCCESS',
  POST_IMG_AWS_FAILURE: 'POST_IMG_AWS_FAILURE',

  SUBMIT_BULK_POD: 'SUBMIT_BULK_POD',
  SUBMIT_BULK_POD_SUCCESS: 'SUBMIT_BULK_POD_SUCCESS',
  SUBMIT_BULK_POD_FAILURE: 'SUBMIT_BULK_POD_FAILURE',

  REMOVE_RESOURCE_KEY: 'REMOVE_RESOURCE_KEY',

  IMG_UPLOAD_STATUS_SUCCESS: 'IMG_UPLOAD_STATUS_SUCCESS',

  RESET_POD_DTO: 'RESET_POD_DTO',

  SEND_RESPONSE_EVENT_START: 'SEND_RESPONSE_EVENT_START',
  SEND_RESPONSE_EVENT_SUCCESS: 'SEND_RESPONSE_EVENT_SUCCESS',
  SEND_RESPONSE_EVENT_FAILURE: 'SEND_RESPONSE_EVENT_FAILURE',

  RESET_VALIDATOR_CHECK: 'RESET_VALIDATOR_CHECK',

  FETCH_OPERATOR_DETAILS_TDS_START: 'FETCH_OPERATOR_DETAILS_TDS_START',
  FETCH_OPERATOR_DETAILS_TDS_SUCCESS: 'FETCH_OPERATOR_DETAILS_TDS_SUCCESS',
  FETCH_OPERATOR_DETAILS_TDS_FAILURE: 'FETCH_OPERATOR_DETAILS_TDS_FAILURE',

  INITIATE_OPERATOR_TDS_DECLARATION_TDS_START: 'INITIATE_OPERATOR_TDS_DECLARATION_TDS_START',
  INITIATE_OPERATOR_TDS_DECLARATION_TDS_SUCCESS: 'INITIATE_OPERATOR_TDS_DECLARATION_TDS_SUCCESS',
  INITIATE_OPERATOR_TDS_DECLARATION_TDS_FAILURE: 'INITIATE_OPERATOR_TDS_DECLARATION_TDS_FAILURE',
  INITIATE_OPERATOR_TDS_DECLARATION_TDS_RESRET: 'INITIATE_OPERATOR_TDS_DECLARATION_TDS_RESRET',
  INITIATE_OPERATOR_TDS_DECLARATION_TDS_DETAIL_RESET: 'INITIATE_OPERATOR_TDS_DECLARATION_TDS_DETAIL_RESET',

  GET_APP_CONFIG_V2: 'GET_APP_CONFIG_V2',
  GET_APP_CONFIG_V2_SUCCESS: 'GET_APP_CONFIG_V2_SUCCESS',
  GET_APP_CONFIG_V2_FAILURE: 'GET_APP_CONFIG_V2_FAILURE',

  PATCH_APP_CONFIG_V2: 'PATCH_APP_CONFIG_V2',
  PATCH_APP_CONFIG_V2_SUCCESS: 'PATCH_APP_CONFIG_V2_SUCCESS',
  PATCH_APP_CONFIG_V2_FAILURE: 'PATCH_APP_CONFIG_V2_FAILURE',

  FETCH_OPERATOR_TICKETS_START: 'FETCH_OPERATOR_TICKETS_START',
  FETCH_OPERATOR_TICKETS_SUCCESS: 'FETCH_OPERATOR_TICKETS_SUCCESS',
  FETCH_OPERATOR_TICKETS_FAILURE: 'FETCH_OPERATOR_TICKETS_FAILURE',

  GET_TRIP_REMARKS: 'TRIPS/GET_TRIP_REMARKS',
  GET_TRIP_REMARKS_SUCCESS: 'TRIPS/GET_TRIP_REMARKS_SUCCESS',
  GET_TRIP_REMARKS_FAILURE: 'TRIPS/GET_TRIP_REMARKS_FAILURE',

  GET_TIME_SLOTS: 'TRIPS/GET_TIME_SLOTS',
  GET_TIME_SLOTS_SUCCESS: 'TRIPS/GET_TIME_SLOTS_SUCCESS',
  GET_TIME_SLOTS_FAILURE: 'TRIPS/GET_TIME_SLOTS_FAILURE',

  PATCH_REMARKS: 'TRIPS/PATCH_REMARKS',
  PATCH_REMARKS_SUCCESS: 'TRIPS/PATCH_REMARKS_SUCCESS',
  PATCH_REMARKS_FAILURE: 'TRIPS/PATCH_REMARKS_FAILURE',

  FETCH_OPERATOR_POLICY_STATUS_START: 'FETCH_OPERATOR_POLICY_STATUS_START',
  FETCH_OPERATOR_POLICY_STATUS_SUCCESS: 'FETCH_OPERATOR_POLICY_STATUS_SUCCESS',
  FETCH_OPERATOR_POLICY_STATUS_FAILURE: 'FETCH_OPERATOR_POLICY_STATUS_FAILURE',
  FETCH_OPERATOR_POLICY_STATUS_RESET: 'FETCH_OPERATOR_POLICY_STATUS_RESET',

  POST_OPERATOR_POLICY_ACCEPT_START: 'POST_OPERATOR_POLICY_ACCEPT_START',
  POST_OPERATOR_POLICY_ACCEPT_SUCCESS: 'POST_OPERATOR_POLICY_ACCEPT_SUCCESS',
  POST_OPERATOR_POLICY_ACCEPT_FAILURE: 'POST_OPERATOR_POLICY_ACCEPT_FAILURE',

  FETCH_SUBSCRIPTION_CONFIG: 'FETCH_SUBSCRIPTION_CONFIG',
  FETCH_SUBSCRIPTION_SUCCESS: 'FETCH_SUBSCRIPTION_CONFIG_SUCCESS',
  FETCH_SUBSCRIPTION_FAILURE: 'FETCH_SUBSCRIPTION_CONFIG_FAILURE',

  POST_CANCEL_REASON: 'POST_CANCEL_REASON',
  POST_CANCEL_REASON_SUCCESS: 'POST_CANCEL_REASON_SUCCESS',
  POST_CANCEL_REASON_FAILURE: 'POST_CANCEL_REASON_FAILURE',

  FETCH_TRIP_FILTERS: 'FETCH_TRIP_FILTERS',
  FETCH_TRIP_FILTERS_SUCCESS: 'FETCH_TRIP_FILTERS_SUCCESS',
  FETCH_TRIP_FILTERS_FAILURE: 'FETCH_TRIP_FILTERS_FAILURE',
  APPLY_FILTER: 'TRIPS/APPLY_FILTER',
  FETCH_SETTINGS_REQUEST: 'FETCH_SETTINGS_REQUEST',
  FETCH_SETTINGS_SUCCESS: 'FETCH_SETTINGS_SUCCESS',
  FETCH_SETTINGS_FAILURE: 'FETCH_SETTINGS_FAILURE',
  SAVE_SETTINGS_REQUEST: 'SAVE_SETTINGS_REQUEST',
  SAVE_SETTINGS_SUCCESS: 'SAVE_SETTINGS_SUCCESS',
  SAVE_SETTINGS_FAILURE: 'SAVE_SETTINGS_FAILURE',

  PATCH_PAN_ADHAAR: 'PATCH_PAN_ADHAAR',

  DEMAND_EDIT_CONFIRMATION_REQUEST: 'DEMAND_EDIT_CONFIRMATION_REQUEST',
  DEMAND_EDIT_CONFIRMATION_SUCCESS: 'DEMAND_EDIT_CONFIRMATION_SUCCESS',
  DEMAND_EDIT_CONFIRMATION_FAILURE: 'DEMAND_EDIT_CONFIRMATION_FAILURE',

  GET_RAITING_TRAINING_REQUEST: 'GET_RAITING_TRAINING_REQUEST',
  GET_RAITING_TRAINING_SUCCESS: 'GET_RAITING_TRAINING_SUCCESS',
  GET_RAITING_TRAINING_FAILURE: 'GET_RAITING_TRAINING_FAILURE',

  GET_INVOICE_REQUEST: 'GET_INVOICE_REQUEST',
  GET_INVOICE_SUCCESS: 'GET_INVOICE_SUCCESS',
  GET_INVOICE_FAILURE: 'GET_INVOICE_FAILURE',

  PATCH_INVOICE_REQUEST: 'PATCH_INVOICE_REQUEST',
  PATCH_INVOICE_SUCCESS: 'PATCH_INVOICE_SUCCESS',
  PATCH_INVOICE_FAILURE: 'PATCH_INVOICE_FAILURE',

  UPLOAD_IMAGE_REQUEST: 'UPLOAD_IMAGE_REQUEST',
  UPLOAD_IMAGE_SUCCESS: 'UPLOAD_IMAGE_SUCCESS',
  UPLOAD_IMAGE_FAILURE: 'UPLOAD_IMAGE_FAILURE',

  UPLOAD_IMAGE_AWS_REQUEST: 'UPLOAD_IMAGE_AWS_REQUEST',
  UPLOAD_IMAGE_AWS_SUCCESS: 'UPLOAD_IMAGE_AWS_SUCCESS',
  UPLOAD_IMAGE_AWS_FAILURE: 'UPLOAD_IMAGE_AWS_FAILURE',

  FETCH_WELANG: 'FETCH_WELANG',
  FETCH_WELANG_SUCCESS: 'FETCH_WELANG_SUCCESS',
  FETCH_WELANG_FAILURE: 'FETCH_WELANG_FAILURE',

  GET_TRAINING_CONTENT_REQUEST: 'GET_TRAINING_CONTENT_REQUEST',
  GET_TRAINING_CONTENT_SUCCESS: 'GET_TRAINING_CONTENT_SUCCESS',
  GET_TRAINING_CONTENT_FAILURE: 'GET_TRAINING_CONTENT_FAILURE',

  FETCH_TRAINING_CONTENT_V2_REQUEST: 'FETCH_TRAINING_CONTENT_V2_REQUEST',
  FETCH_TRAINING_CONTENT_V2_SUCCESS: 'FETCH_TRAINING_CONTENT_V2_SUCCESS',
  FETCH_TRAINING_CONTENT_V2_FAILURE: 'FETCH_TRAINING_CONTENT_V2_FAILURE',

  FETCH_DETENTION_CONTENT_REQUEST: 'FETCH_DETENTION_CONTENT_REQUEST',
  FETCH_DETENTION_CONTENT_SUCCESS: 'FETCH_DETENTION_CONTENT_SUCCESS',
  FETCH_DETENTION_CONTENT_FAILURE: 'FETCH_DETENTION_CONTENT_FAILURE',

  PUT_COMPLETE_TRAINING_REQUEST: 'PUT_COMPLETE_TRAINING_REQUEST',
  PUT_COMPLETE_TRAINING_SUCCESS: 'PUT_COMPLETE_TRAINING_SUCCESS',
  PUT_COMPLETE_TRAINING_FAILURE: 'PUT_COMPLETE_TRAINING_FAILURE',

  EMPTY_TRAINING_CONTENT: 'EMPTY_TRAINING_CONTENT',

  // SESSION UPDATE API (common for all session operations)
  SESSION_UPDATE_REQUEST: 'SESSION_UPDATE_REQUEST',
  SESSION_UPDATE_SUCCESS: 'SESSION_UPDATE_SUCCESS',
  SESSION_UPDATE_FAILURE: 'SESSION_UPDATE_FAILURE',

  POST_ACKNOWLEDGEMENT: 'POST_ACKNOWLEDGEMENT',
  POST_ACKNOWLEDGEMENT_SUCCESS: 'POST_ACKNOWLEDGEMENT_SUCCESS',
  POST_ACKNOWLEDGEMENT_FAILURE: 'POST_ACKNOWLEDGEMENT_FAILURE',

  FETCH_RATE_CARDS: 'FETCH_RATE_CARDS',
  FETCH_RATE_CARDS_SUCCESS: 'FETCH_RATE_CARDS_SUCCESS',
  FETCH_RATE_CARDS_FAILURE: 'FETCH_RATE_CARDS_FAILURE',
  SUBMIT_USER_RATE_CARD_RESPONSE: 'SUBMIT_USER_RATE_CARD_RESPONSE',
  SUBMIT_USER_RATE_CARD_RESPONSE_SUCCESS: 'SUBMIT_USER_RATE_CARD_RESPONSE_SUCCESS',
  SUBMIT_USER_RATE_CARD_RESPONSE_FAILURE: 'SUBMIT_USER_RATE_CARD_RESPONSE_FAILURE',

  RESET_RATE_CARDS: 'RESET_RATE_CARDS',

  GET_REMARKS_LIST: 'GET_REMARKS_LIST',
  GET_REMARKS_LIST_SUCCESS: 'GET_REMARKS_LIST_SUCCESS',
  GET_REMARKS_LIST_FAILURE: 'GET_REMARKS_LIST_FAILURE',

  UPDATE_DELAY_REMARKS: 'UPDATE_DELAY_REMARKS',
  UPDATE_DELAY_REMARKS_SUCCESS: 'UPDATE_DELAY_REMARKS_SUCCESS',
  UPDATE_DELAY_REMARKS_FAILURE: 'UPDATE_DELAY_REMARKS_FAILURE',

  REASON_SUBMIT_START: 'REASON_SUBMIT_START',
  REASON_SUBMIT_SUCCESS: 'REASON_SUBMIT_SUCCESS',
  REASON_SUBMIT_FAILURE: 'REASON_SUBMIT_FAILURE',

  FETCH_ADVANCE_STATE_VIEW_START: 'FETCH_ADVANCE_STATE_VIEW_START',
  FETCH_ADVANCE_STATE_VIEW_SUCCESS: 'FETCH_ADVANCE_STATE_VIEW_SUCCESS',
  FETCH_ADVANCE_STATE_VIEW_FAILURE: 'FETCH_ADVANCE_STATE_VIEW_FAILURE',
};

export default types;
